import axios from '../axiosConfig.jsx'

export default async function saveRoomTableConfig(data) {
    return await axios.post('/admins/room_table_config', data).then(res => res.data)
}